import { Menubar } from "@/components/ui/menubar";
import { memo, PropsWithChildren } from "react";
import ListColumnsMenuBarMenu from "./ListColumnsMenuBarMenu";
import ListResetMenuBarMenu from "./ListResetMenuBarMenu";
import ListToolsMenuBarMenu from "./ListToolsMenuBarMenu";
import { cn } from "@/lib/utils";

interface ListMenubarProps extends PropsWithChildren {
  className?: string;
}

interface ListMenubarComponent
  extends React.MemoExoticComponent<React.FC<ListMenubarProps>> {
  Tools: typeof ListToolsMenuBarMenu;
  Columns: typeof ListColumnsMenuBarMenu;
  Reset: typeof ListResetMenuBarMenu;
}

export const ListMenubar = memo(({ children, className }: ListMenubarProps) => {
  return <Menubar className={cn("mb-2", className)}>{children}</Menubar>;
}) as ListMenubarComponent;

ListMenubar.Tools = ListToolsMenuBarMenu;
ListMenubar.Columns = ListColumnsMenuBarMenu;
ListMenubar.Reset = ListResetMenuBarMenu;
